export default `float de(vec3 p){
    float le = 0.13;  
    float r1 = 0.20;  
    float r2 = 0.09;  

    vec3 q = vec3( p.x, max(abs(p.y)-le,0.0), p.z );
    return length(vec2(length(q.xy)-r1,q.z)) - r2;
  }`